const t = "Pulsa Intro para editar", s = {
  pressEnterToEdit: t
};
export {
  s as default,
  t as pressEnterToEdit
};
